module.exports = __webpack_public_path__ + "img/Catalina Hummer Jeep.0cdc596b.png";